import { IBaseModel } from '../base/base-model.interface';
import { createEnumOptions } from '../shared/enum-option.interface';

export enum SendStatus {
  pending = 0,
  success = 1,
  fail = 2,
}

export enum MailType {
  ticketCreated = 1,
  setPassword = 2,
  ticketMessageCreated = 3,
  ticketAssigned = 4,
  orderChanged = 5,
  reportPublished = 6,
  oltAssignedSp = 7,
  customNotification = 8,
  ticketUpdated = 9,
  profilacticCreated = 10,
  newProfilacticComment = 11,
  profilacticUpdated = 12,
  colocationCreated = 13,
  colocationPriceQuote = 14,
  colocationConstructionOrder = 15,
  colocationFinished = 16,
  colocationReopened = 17,
  colocationCancelled = 18,
  colocationPortReservationCancelled = 19,
  colocationAssigned = 20,
  profilacticNotification = 21,
  oltSubmitted = 22,
  oltAllowedIsp = 23,
  nonDocumentedOrders = 24,
  colocationPortReservation = 25,
  newColocationComment = 26,
}

export const colocationMailsTypesOptions = createEnumOptions({
  [MailType.colocationCreated]: { label: 'Vytvorenie kolokácie' },
  [MailType.colocationPriceQuote]: { label: 'Cenová ponuka kolokácie' },
  [MailType.colocationConstructionOrder]: {
    label: 'Objednávka výstavby kolokácie',
  },
  [MailType.colocationFinished]: { label: 'Dokončenie kolokácie' },
  [MailType.colocationReopened]: { label: 'Znovuotvorenie kolokácie' },
  [MailType.colocationCancelled]: { label: 'Zrušenie kolokácie' },
  [MailType.colocationPortReservationCancelled]: {
    label: 'Zrušenie rezervácie portu kolokácie',
  },
  _default: { label: '-' },
});

export interface IEmail extends IBaseModel<'Email'> {
  email: string | string[];
  type?: MailType;
  content?: string;
  sendStatus: SendStatus;
}
